import React from 'react'
import Layout from '../../Components/Layout'
import BannerGlobal from '../../Components/BannerGlobal'
import FAQs from '../../Components/FAQs'
import useDocumentTitle from '../../Hooks/PageTitle'

const FAQsPage = () => {
  useDocumentTitle("TRoo Web Design Agency | FAQs Page")
  return (
    <Layout>
        <BannerGlobal/>
        <FAQs/>
    </Layout>
  )
}

export default FAQsPage